import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  patchTransportSedel,
  TransportSedelQueryKey,
} from "api/transportSedel.api";
import { UppdragQueryKey } from "api/uppdrag.api";
import { useNotification } from "hooks/useNotification";
import { useState } from "react";
import { TransportSedel } from "types/transportSedel.type";

export const useSignatureModalLogic = (
  transportSedel: TransportSedel,
  fieldName: keyof TransportSedel,
  notAvailableFieldName?: keyof TransportSedel,
) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const queryClient = useQueryClient();
  const notification = useNotification();

  const mutation = useMutation({
    ...patchTransportSedel(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [UppdragQueryKey.GetOne] });
      queryClient.invalidateQueries({ queryKey: [UppdragQueryKey.GetList] });
      queryClient.invalidateQueries({
        queryKey: [TransportSedelQueryKey.GetList],
      });
      setIsModalOpen(false);
    },
    onError: () => {
      notification.error();
    },
  });

  const onSubmit = (signature?: string | null) => {
    mutation.mutate({
      id: transportSedel.id,
      payload: {
        [fieldName]: signature,
      },
    });
  };

  const onNotAvailableSubmit = () => {
    if (!notAvailableFieldName) {
      console.error("notAvailableFieldName is missing");
      return;
    }
    mutation.mutate({
      id: transportSedel.id,
      payload: {
        [notAvailableFieldName]: true,
      },
    });
  };

  return {
    isModalOpen,
    openModal: () => setIsModalOpen(true),
    isPending: mutation.isPending,
    onSubmit,
    onNotAvailableSubmit,
    closeModal: () => setIsModalOpen(false),
  };
};
